"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("../assets/css/font-face.css");

require("./Alert.css");

var _fi = require("react-icons/fi");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Alert = function Alert(_ref) {
  var color = _ref.color,
      withIcon = _ref.withIcon,
      className = _ref.className,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["color", "withIcon", "className", "children"]);

  var wrapperClass = 'alert';
  if (color === 'info') wrapperClass += ' alert--info';
  if (color === 'success') wrapperClass += ' alert--success';
  if (color === 'danger') wrapperClass += ' alert--danger';
  if (color === 'warning') wrapperClass += ' alert--warning';
  if (className) wrapperClass += " ".concat(className);
  return _react.default.createElement("div", _extends({}, props, {
    className: wrapperClass
  }), withIcon && _react.default.createElement("i", {
    className: "alert__icon"
  }, renderIcon(color)), children);
};

var renderIcon = function renderIcon(color) {
  switch (color) {
    case 'info':
      return _react.default.createElement(_fi.FiAlertCircle, {
        size: "25"
      });

    case 'success':
      return _react.default.createElement(_fi.FiCheckCircle, {
        size: "25"
      });

    case 'danger':
      return _react.default.createElement(_fi.FiAlertOctagon, {
        size: "25"
      });

    case 'warning':
      return _react.default.createElement(_fi.FiAlertTriangle, {
        size: "25"
      });

    /* istanbul ignore next */

    default:
      return null;
  }
};

Alert.propTypes = {
  color: _propTypes.default.oneOf(['info', 'success', 'danger', 'warning']),
  withIcon: _propTypes.default.bool,
  className: _propTypes.default.string,
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]).isRequired
};
var _default = Alert;
exports.default = _default;